const EyeSlash = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.836"
      height="19.069"
      viewBox="0 0 23.836 19.069"
    >
      <path
        data-name="Icon awesome-eye-slash"
        d="M11.918 14.9A5.343 5.343 0 0 1 6.6 9.94L2.689 6.92a12.413 12.413 0 0 0-1.368 2.07 1.2 1.2 0 0 0 0 1.087 11.945 11.945 0 0 0 10.6 6.607 11.568 11.568 0 0 0 2.9-.39l-1.933-1.5a5.368 5.368 0 0 1-.968.1zm11.688 2.164-4.117-3.182a12.337 12.337 0 0 0 3.026-3.8 1.2 1.2 0 0 0 0-1.087 11.945 11.945 0 0 0-10.6-6.607 11.476 11.476 0 0 0-5.487 1.4L1.693.125a.6.6 0 0 0-.836.1l-.731.941a.6.6 0 0 0 .1.836l21.916 16.941a.6.6 0 0 0 .836-.1l.731-.941a.6.6 0 0 0-.105-.836zm-6.842-5.288L15.3 10.641A3.529 3.529 0 0 0 10.975 6.1a1.775 1.775 0 0 1 .347 1.051 1.737 1.737 0 0 1-.057.372L8.523 5.4a5.3 5.3 0 0 1 3.395-1.233 5.36 5.36 0 0 1 5.363 5.363 5.236 5.236 0 0 1-.518 2.239z"
        style={{ fill: "#b1acab" }}
      />
    </svg>
  );
};

export default EyeSlash;
